import Box from '@mui/material/Box'
import DialogContent from '@mui/material/DialogContent'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const StyledErrorBox = styled(Box)`
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #d32f2f;
`

export const ErrorDialogContentWrapper = styled(DialogContent)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 14px;
`

export const CloseIconWrapper = styled('div')`
  display: flex;
  cursor: pointer;
  text-transform: uppercase;
  color: ${colors.bodyText};
  font-size: 13px;
  font-weight: 500;
`

export const MiddleSectionWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  color: ${colors.bodyText};
`

export const DialogContentHeader = styled('h4')`
  margin-top: 0;
  margin-bottom: 4px;
  font-weight: 500;
`
